/**
 * "Mostrando a–b de total" pagination math -- the single shared
 * implementation for `components/Pagination.tsx`'s `variant="range"` status
 * text and `features/contacts/derived.ts`'s own re-export of the same
 * contract (RDD review-reliability, WARNING, R3-001/R3-002: these used to be
 * two independently-maintained private copies, each only guarding
 * `total <= 0`, so `page` past the last page, `page < 1`, or a non-positive
 * `size` could still invert the range -- e.g. page=4/size=20/total=45
 * rendered "Mostrando 61–45 de 45"). A stale page after a filter shrinks the
 * result set is a real, reachable case, not just a defensive guard.
 */
export function computeShowingRange(page: number, size: number, total: number): { from: number; to: number } {
  if (total <= 0 || size <= 0) {
    return { from: 0, to: 0 };
  }
  const totalPages = Math.max(1, Math.ceil(total / size));
  const clampedPage = Math.min(Math.max(1, page), totalPages);
  const from = (clampedPage - 1) * size + 1;
  const to = Math.min(clampedPage * size, total);
  return { from, to };
}
